export default {
    url: '/dynamic',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        priority: 801,
        title: 'Dynamic',
        role: 'arpu',
    },
};
